module.exports = (value, monetary = true) => {
  // console.log("Rounding value " + value);
  try {
    if(isNaN(value)){
      value = 0
    }
    if(monetary){
      value = parseFloat(value).toFixed(2);
    }else{
     value =  Math.round(value * 100) / 100

    }
    
  } catch (error) {
    
  }
  
  return value;
};



// WEBPACK FOOTER //
// ./src/services/roundy.js